<template>
  <div class="app-container">{{ $t('route.staffManagement') }}</div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
</style>
